const CACHE_TTL_MS = 5 * 60 * 1000;

const cache = new Map(); // key → { data, expiresAt }
const inFlight = new Map(); // key → Promise

const buildKey = (url, params) => {
  const sorted = params
    ? Object.entries(params)
        .filter(([, v]) => v !== undefined && v !== null)
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([k, v]) => `${k}=${v}`)
        .join('&')
    : '';
  return sorted ? `${url}?${sorted}` : url;
};

export const cachedGet = (axiosInstance, url, params, ttlMs = CACHE_TTL_MS) => {
  const key = buildKey(url, params);

  const entry = cache.get(key);
  if (entry && Date.now() < entry.expiresAt) {
    return Promise.resolve(entry.data);
  }

  const existing = inFlight.get(key);
  if (existing) return existing;

  const promise = axiosInstance
    .get(url, { params })
    .then((response) => {
      cache.set(key, { data: response, expiresAt: Date.now() + ttlMs });
      inFlight.delete(key);
      return response;
    })
    .catch((err) => {
      inFlight.delete(key);
      throw err;
    });

  inFlight.set(key, promise);
  return promise;
};

export const invalidateKey = (url, params) => {
  const key = buildKey(url, params);
  cache.delete(key);
};

export const clearAll = () => {
  cache.clear();
  inFlight.clear();
};
